import { ARTICULOS_AYUDA, type CategoriaFaqArticulo } from './ayuda/articulos';

export interface FAQ {
    id: string;
    question: string;
    answer: string;
    category: FAQCategory;
}

export enum FAQCategory {
    SETUP = "Primeros Pasos & Configuración",
    SECURITY = "Seguridad & Privacidad",
    PRICING = "Planes & Facturación",
    CLINICAL = "Uso Clínico & Funcionalidades",
    TECHNICAL = "Problemas Técnicos",
}

const CATEGORIA_POR_CLAVE: Readonly<Record<CategoriaFaqArticulo, FAQCategory>> = {
    SETUP: FAQCategory.SETUP,
    SECURITY: FAQCategory.SECURITY,
    PRICING: FAQCategory.PRICING,
    CLINICAL: FAQCategory.CLINICAL,
    TECHNICAL: FAQCategory.TECHNICAL,
};

/**
 * Las preguntas frecuentes se DERIVAN de los artículos de ayuda que llevan un bloque `faq` (D-27, D-56).
 *
 * Por qué no se escriben aquí: la respuesta que ve el terapeuta en el acordeón de /ayuda, la que sirve el
 * chatbot público de preguntas frecuentes y la que cita el asistente del tablero (`config/ayudaProducto.json`,
 * generado desde los mismos artículos) tienen que ser la misma frase. Con tres copias a mano, una de ellas
 * acaba contradiciendo a las otras. La pregunta es el título del artículo y la respuesta, su respuesta corta.
 * Los nombres exportados, `FAQ` y `FAQCategory` no cambian: solo cambia de dónde salen los datos.
 */
export const faqs: FAQ[] = ARTICULOS_AYUDA.flatMap((articulo) =>
    articulo.faq
        ? [{
            id: articulo.faq.id,
            category: CATEGORIA_POR_CLAVE[articulo.faq.categoria],
            question: articulo.titulo,
            answer: articulo.respuestaCorta,
        }]
        : [],
);
